// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ccdaa90f","453":"bcaa3dbf","455":"ff8d1d24","977":"204eb1bf"}[chunkId] + ".chunk.js";
};